import { empty } from 'rxjs/observable/empty';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { combineEpics } from 'redux-observable';
import { FetchAttributes, UpdatePhoneNumber, UpdateLanguageWithLocale, UpdateLanguageWithLocaleActionTypes, UpdateLocaleWithLanguage, UpdateLocaleWithLanguageActionTypes, UpdateUnsubscribeLink, UpdateDefaultHome, UpdateDefaultPhoneCountryCode, LOAD_ATTRIBUTES, UPDATE_PHONE_NUMBER, UPDATE_LANGUAGE, UPDATE_LANGUAGE_WITH_LOCALE, UPDATE_LOCALE, UPDATE_LOCALE_WITH_LANGUAGE, UPDATE_UNSUBSCRIBE_LINK, UPDATE_DEFAULT_PHONE_COUNTRY_CODE, UPDATE_DEFAULT_HOME } from '../actions/AttributeActions';
import { getCurrentUserLanguage } from '../selectors/AttributesSelector';
import { getFetchAttributesRequestStatus, getUpdatePhoneNumberRequestStatus, getUpdateLanguageRequestStatus, getUpdateLocaleRequestStatus, getUpdateUnsubscribeLinkRequestStatus, getUpdateDefaultPhoneCountryCodeRequestStatus, getUpdateDefaultHomeRequestStatus } from '../selectors/RequestStatusSelector';
import { getLanguagesToDefaultLocales } from '../selectors/ProfileOptionsSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import AttributesAPI from '../api/AttributesAPI';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchAttributes = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.getAttributes,
  initiatingActionType: LOAD_ATTRIBUTES,
  requestStatusSelector: getFetchAttributesRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchAttributes
}));
const updateDefaultPhoneCountryCode = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateDefaultPhoneCountryCode,
  initiatingActionType: UPDATE_DEFAULT_PHONE_COUNTRY_CODE,
  requestStatusSelector: getUpdateDefaultPhoneCountryCodeRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateDefaultPhoneCountryCode,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const updatePhoneNumber = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updatePhoneNumber,
  initiatingActionType: UPDATE_PHONE_NUMBER,
  requestStatusSelector: getUpdatePhoneNumberRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdatePhoneNumber,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const updateLanguage = ($action, {
  getState
}) => {
  return $action.ofType(UPDATE_LANGUAGE).pipe(map(action => {
    const language = action.payload.data;
    const locale = getLanguagesToDefaultLocales(getState())[language];
    return {
      type: UPDATE_LANGUAGE_WITH_LOCALE,
      payload: {
        data: {
          language,
          locale
        }
      }
    };
  }));
};
const updateLocale = ($action, {
  getState
}) => {
  return $action.ofType(UPDATE_LOCALE).pipe(map(action => {
    const language = getCurrentUserLanguage(getState());
    return {
      type: UPDATE_LOCALE_WITH_LANGUAGE,
      payload: {
        data: {
          language,
          locale: action.payload.data
        }
      }
    };
  }));
};
const updateLanguageRequest = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateLanguageAndLocale,
  initiatingActionType: UPDATE_LANGUAGE_WITH_LOCALE,
  requestStatusSelector: getUpdateLanguageRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateLanguageWithLocale,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const updateLocaleRequest = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateLanguageAndLocale,
  initiatingActionType: UPDATE_LOCALE_WITH_LANGUAGE,
  requestStatusSelector: getUpdateLocaleRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateLocaleWithLanguage,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const refreshOnLanguageUpdate = $action => {
  return $action.ofType(UpdateLanguageWithLocaleActionTypes.SUCCESS).pipe(mergeMap(() => {
    const newLocation = window.location.search.indexOf('?') >= 0 ? `${window.location.href}&languageUpdated=true` : `${window.location.href}?languageUpdated=true`;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
    window.location = newLocation;
    return empty();
  }));
};
const refreshOnLocaleUpdate = $action => {
  return $action.ofType(UpdateLocaleWithLanguageActionTypes.SUCCESS).pipe(mergeMap(() => {
    window.location.reload();
    return empty();
  }));
};
const updateUnsubscribeLink = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateUnsubscribeLink,
  initiatingActionType: UPDATE_UNSUBSCRIBE_LINK,
  requestStatusSelector: getUpdateUnsubscribeLinkRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateUnsubscribeLink,
  alertOnSuccess: true,
  alertOnFailure: true
}));
const updateDefaultHome = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateDefaultHome,
  initiatingActionType: UPDATE_DEFAULT_HOME,
  requestStatusSelector: getUpdateDefaultHomeRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateDefaultHome,
  alertOnSuccess: true,
  alertOnFailure: true
}));
export default combineEpics(fetchAttributes, updateDefaultPhoneCountryCode, updatePhoneNumber, updateLanguage, updateLanguageRequest, updateLocale, updateLocaleRequest, refreshOnLanguageUpdate, refreshOnLocaleUpdate, updateUnsubscribeLink, updateDefaultHome);